// Add select2 to variation dropdown on single article page
jQuery(document).ready(function ($) {
    $('#groesse').select2()
})